
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/design-system",
      function () {
        return require("private-next-pages/services/design-system.tsx");
      }
    ]);
  